export const BED_TYPES = [
  { type: "King Bed",             pax: 1, region: "USA" },
  { type: "King and Sofabed",     pax: 2, region: "USA" },
  { type: "Queen Bed",            pax: 1, region: "USA" },
  { type: "2 Queen Beds",         pax: 2, region: "USA" },
  { type: "2 Double Beds",        pax: 2, region: "USA" },
  { type: "Twin Bed",             pax: 2, region: "USA" },
  { type: "Twin XL",              pax: 2, region: "USA" },
  { type: "California King",      pax: 1, region: "USA" },
  { type: "Rollaway / Extra Bed", pax: 1, region: "USA" },
  { type: "Single Bed",           pax: 1, region: "International" },
  { type: "Twin Beds",            pax: 2, region: "International" },
  { type: "Double Bed",           pax: 2, region: "International" },
  { type: "King Bed",             pax: 2, region: "International" },
  { type: "Super King Bed",       pax: 2, region: "International" },
  { type: "Rollaway / Extra Bed", pax: 1, region: "International" },
  { type: "Sofa Bed",             pax: 1, region: "International" },
  { type: "French Bed",           pax: 2, region: "International" },
];

export const ROOM_TYPES = [
  "Bungalow",
  "Corner Room",
  "Deluxe Room",
  "Executive/Premium Room",
  "Junior Suite",
  "Presidential / Royal Suite",
  "Standard Room",
  "Studio",
  "Suite",
  "Villa",
];

export const ROOM_FEATURES = [
  "Ocean View",
  "City View",
  "Mountain View",
  "Garden View",
  "Lake View",
  "Accessible",
  "Adjoining",
  "Connecting",
];

export function bedTypeLabel(bed) {
  return `${bed.type} (${bed.region}) · ${bed.pax} PAX`;
}

/** Sum of bed.count × pax across a Configuration's beds array (total sleeping capacity). */
export const totalCapacity = (beds) => (beds || []).reduce((sum, b) => {
  const pax = BED_TYPES.find((bt) => bt.type === b.type && bt.region === b.region)?.pax || 0;
  return sum + b.count * pax;
}, 0);
